import React from "react"
import { ColorPickerSeeker } from "@ui-seeker/core"

import { useUserSettingsCategory, useUserSettingsCategoryValidator } from "../../../@hooks"
import { userSettingCategoryFormData } from "../../../@signals"


export default function UserSettingCategoryDrawerColor() {
	const { handleChangeCategoryFormData } = useUserSettingsCategory()
	const { colorError } = useUserSettingsCategoryValidator()

    return <ColorPickerSeeker
		value={userSettingCategoryFormData.value?.color}
		onChange={newColor => handleChangeCategoryFormData(newColor, 'color')}
		label="Color"
		error={colorError}
	/>
}